export * from '@primeuix/themes/nora/divider';
export { default } from '@primeuix/themes/nora/divider';
